import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBy9Pv6r5erBK33K5xHqQ_kurfsNxAKdp8",
  authDomain: "mychiro-43c09.firebaseapp.com",
  projectId: "mychiro-43c09",
  storageBucket: "mychiro-43c09.firebasestorage.app",
  messagingSenderId: "478635984331",
  appId: "1:478635984331:web:9591051b66b9d6ef6be24e",
  measurementId: "G-33Z99MJ8E8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app); 